// extracted by mini-css-extract-plugin
export default {"icon":"SSB0w1FxqaRB3SmY0zDK","pink":"OSiS2HBYNxQzL4psi8g6"};